import { Trans, useTranslation } from 'react-i18next';
import { SubscribedProduct } from '../../../queries/ats/me/products/types';
import { FocusedAsset } from '../use-focused-asset';
import { getPurchaseModalTitleName } from './utils';
import css from './purchase-product-modal.module.scss';
import React from 'react';
import { Link } from '../../../components/Link';
import { classes } from '../../../utils/commonUtils';
import { routes } from '../../../config';
import { SvgPlayFilled } from '../../../icons';

interface PurchaseSuccessProps {
  product: SubscribedProduct;
  asset: FocusedAsset;
}

export function PurchaseSuccess({ product, asset }: PurchaseSuccessProps) {
  const { t } = useTranslation();

  const title = getPurchaseModalTitleName(asset);

  const ctaText =
    asset.type === 'episode'
      ? `${t('see episode')} ${asset.episode.sequenceNumber} ${t('now')}`
      : t('details:watch-now');

  const purchaseType = product.type === 'purchase' ? 'purchased' : 'rented';

  return (
    <>
      <p className={css.confirmationText}>
        <Trans
          i18nKey="details:purchase-success"
          values={{
            purchaseType: t('common:' + purchaseType).toLowerCase(),
            name: title,
            price: product.price,
          }}
        />
      </p>
      <Link
        className={classes(css.button, css.success)}
        to={`${routes.unmanaged.base}${routes.playback}/${product.platformTitleId}`}
      >
        <span>
          <SvgPlayFilled />
        </span>
        {ctaText}
      </Link>
    </>
  );
}
